import{STRAPI_BASE_URL} from '../../config/config'
import useCardComponent from "./useCardComponent";

export default function CardComponent ({img ="",title ="",url="",width = '',padding = ''}) {

    return (
    <div className="card-width-style col-xs-6">
        <div className="card">
            <a href={url}>
            <img src={STRAPI_BASE_URL + img} alt="Mobile"/>
            </a>
        </div>
        <div className="">
            <p>{title}</p>
        </div>
    </div>
    )
}



